<template>
    <b-nav id="sidebar" vertical class="sidebar">
        <div class="sidebar-header">
            <h3>DGHS Backend</h3>
        </div>
        <b-nav-item :to="{ name: 'Home' }">Rückmeldungen</b-nav-item>
        <b-nav-item :to="{ name: 'Members' }">Mitglieder</b-nav-item>


        <b-nav-item @click="logout" style="margin-top: 50px">Logout</b-nav-item>

    </b-nav>
</template>

<script>
    export default {
        name: "Sidebar",
        mounted() {

        },
        methods: {
            logout() {
                localStorage.removeItem("user")
                this.$router.replace({ name: 'Login' })
            }
        },
        data() {
            return {
            }
        },
    }

</script>

<style>

    #sidebar {
        width: 180px;
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        z-index: 999;
        background: #3f5063;
        color: #fff;
        transition: all 0.3s;
    }

    #sidebar .sidebar-header {
        padding: 20px;
    }



    #sidebar .nav-link {
        padding: 15px;
        font-size: 1.1em;
        display: block;
        color: #ffffff;
        /*color: #42b983;*/
    }

    #sidebar .nav-link:hover {
        color: #3f5063;
        background: #fff;
    }

    #sidebar .nav-link.router-link-active,
    a[aria-expanded="true"] {
        color: #3f5063;
        background: #c2c2c2;
    }


    a,
    a:hover,
    a:focus {
        color: inherit;
        text-decoration: none;
        transition: all 0.3s;
    }
</style>

